import { render, staticRenderFns } from "./stocks-maintenance.vue?vue&type=template&id=0b1f15ee&"
import script from "./stocks-maintenance.vue?vue&type=script&lang=js&"
export * from "./stocks-maintenance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports